






import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStaticsStaff, AcgnStaticsMenu } from '@/components';

@Component({
  components: {
    AcgnStaticsStaff,
    AcgnStaticsMenu
  },
  mixins: [RenderMenuMixin]
})

/**
 * 员工数据
 */
export default class StatisticStaff extends Vue {

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="staff"></acgn-statics-menu>
    );
  }
}
